module.exports = __webpack_public_path__ + "img/Anjan.3c218722.jpg";